import { render, staticRenderFns } from "./CompanyAvatar.vue?vue&type=template&id=58dc7c60&scoped=true&"
import script from "./CompanyAvatar.vue?vue&type=script&lang=js&"
export * from "./CompanyAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAvatar.vue?vue&type=style&index=0&id=58dc7c60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc7c60",
  null
  
)

export default component.exports